import React from 'react';

import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import isNil from 'lodash/isNil';

import { notificationService, MESSAGELEVEL } from '../../subjects/common/NotificationService';

export default class Notification extends React.Component {
    componentDidMount() {
        this.subscription = notificationService.get().subscribe({
            next: ({ title, content, messageLevel, cssClass, duration, showCloseButton }) => {
                this.toastInstance.content = this.renderContent(content);
                this.toastInstance.showCloseButton = showCloseButton;
                switch (messageLevel) {
                    case MESSAGELEVEL.SUCCESS:
                        this.toastInstance.title = title ?? 'Success';
                        this.toastInstance.cssClass = 'e-toast-success';
                        break;
                    case MESSAGELEVEL.WARN:
                        this.toastInstance.title = title ?? 'Warning';
                        this.toastInstance.cssClass = 'e-toast-warning';
                        break;
                    case MESSAGELEVEL.ERROR:
                        this.toastInstance.title = title ?? 'Error';
                        this.toastInstance.cssClass = 'e-toast-danger';
                        break;
                    case MESSAGELEVEL.CUSTOM:
                        this.toastInstance.title = title ?? '';
                        this.toastInstance.cssClass = cssClass;
                        break;
                    default:
                        break;
                }
                this.toastInstance.show({ timeOut: isNil(duration) ? 5000 : duration });
            },
        });
    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    renderContent = (content) => {
        if (typeof content === 'string' || typeof content === 'function' || content == null || content == undefined) {
            return content;
        } else {
            return "Apologies, something isn't working right. Please try again later or contact AVA Support";
        }
    };

    render() {
        return (
            <ToastComponent
                ref={(toast) => (this.toastInstance = toast)}
                position={{ X: '80%', Y: '10%' }}
                data-testid='notification'
            />
        );
    }
}
